<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
    <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Rounded</span>
    <div class="wf-w-1/2">
      <vue-slider
        ref="rounded-slider"
        v-model="rounded"
        :interval="1"
        adsorb
        tooltip="none"
        :duration="0"
        :data="roundedClasses"
      ></vue-slider>
    </div>
  </li>
</template>

<script>
  import _ from 'lodash'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  import { RoundedClasses } from '../classes/RoundedClasses'
  export default MenuStyleProperty.extend({
    computed: {
      roundedClasses() {
        return Object.keys(RoundedClasses)
      },
      rounded: {
        get() {
          let currentRound = this.elementClasses(this.classes)[this.device].find(elementClass => this.roundedClasses.includes(elementClass.value))
            if (! currentRound) {
              currentRound = {property: 'Rounded', value: 'ROUNDED_SM', touched: false}
              this.addToArray(this.module, [currentRound], this.classes, this.device, {}, true, this.parentModule)
            }
            return currentRound.value
        },
        set: _.debounce(function (value) {
          let currentRound = this.elementClasses(this.classes)[this.device].find(elementClass => this.roundedClasses.includes(elementClass.value))
          value = {property: 'Rounded', value: value, touched: currentRound.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }, 250)
      },
    }
  })
</script>
